export const GRADES_COUNT = [1, 2, 3, 4, 5]
